import Icon from "../../../../../imagery/Icon";
import { SelectableFragmentProps } from "./ListItemSelectableFragment.types";

const SelectableFragment: React.FC<SelectableFragmentProps> = ({
	children,
	selected,
}) => {
	return (
		<>
			{children}
			{selected && <Icon name="check" size="md" />}
		</>
	);
};

export default SelectableFragment;
